import React from "react";
import Receipt from "../../../components/Receipt";
import View from "./view";
import config from "../../../config";
import messages from "../../../messages";
import Spinner from "../components/spinner";


export default class BookingView extends View {
    static get title() {
        return "информация о заказе";
    }

    bookingProps() {
        return [
            "clinic",
            "doctor",
            "service",
            "date",
            "time",
            "lastname",
            "firstname",
            "middlename",
            "birthDate",
            "phone",
            "email",
            "utm_source",
        ];
    }

    static get contextTypes() {
        return {
            muiTheme: React.PropTypes.object,
        };
    }

    static get propTypes() {
        return {
            clinic: React.PropTypes.oneOfType([
            React.PropTypes.number,
            React.PropTypes.string
        ]).isRequired,
            doctor: React.PropTypes.string.isRequired,
            service: React.PropTypes.string.isRequired,
            date: React.PropTypes.string.isRequired,
            time: React.PropTypes.string.isRequired,
            lastname: React.PropTypes.string.isRequired,
            firstname: React.PropTypes.string.isRequired,
            middlename: React.PropTypes.string.isRequired,
            birthDate: React.PropTypes.string.isRequired,
            phone: React.PropTypes.string.isRequired,
            email: React.PropTypes.string,
            utm_source: React.PropTypes.string,
        };
    }

    constructor(props) {
        super(props);

        this.state = Object.assign({}, this.state, {
            booking: null,
        });

        this._isMounted = false;
    }

    componentDidMount() {
        this._isMounted = true;
        this.bookPatient();
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    handleRetryClick() {
        this.bookPatient();
    }

    bookPatient() {
        const url = `${config.dataUrl}api.php?function=booking`;

        const urlWithProps = this.bookingProps().reduce((url, propName) => {
            return `${url}&${encodeURIComponent(propName)}=${encodeURIComponent(this.props[propName])}`;
        }, url);

        fetch(urlWithProps).then((response) => {
            return response.json();
        }).then((responseJson) => {
            if (responseJson.status === true) {
                this.setState({
                    booking: responseJson.data,
                });
            } else {
                this.showErrorMessage(responseJson.description);
            }
        }).catch((error) => {
            if (this._isMounted === true) {
                this.showErrorMessage(messages["REQUEST_FAILED"]);
            }
        });
    }

    handleButtonClick() {
        this.props.gotoNextView({
            breadcrumbName: "бронирование",
            nextView: "ConfirmBookingView",
            props: {
                receiptData: this.state.booking,
            }
        });
    }

    render() {
        const colors = this.context.muiTheme.palette;

        if (this.state.isErrorMessageVisible === true) {
            return this.renderErrorMessage();
        }

        if (this.state.booking === null) {
            return <Spinner/>;
        }
        return (
            <div className="appointment-view appointment-view--receipt">
                <div className="appointment-view--info">
                    ВНИМАНИЕ! Ваша бронь не была подтверждена! Вы должны подтвердить бронь.
                </div>
                <Receipt data={this.state.booking} confirmed={false}/>
                <div style={{
                    margin: "2em auto",
                    width: "100%",
                    maxWidth: 360,
                    display: "flex",
                    justifyContent: "flex-end"
                }}
                     className="appointment-form__element">
                    <button
                        style={{
                            backgroundColor: colors.accent5color
                        }}

                        onClick={() => this.handleButtonClick()}
                        type="button"
                        className="appointment-form__button">
                        {"подтвердить"}
                    </button>
                </div>
            </div>
        );
    }
}


/** WEBPACK FOOTER **
 ** ./src/widgets/appointment-widget/views/booking.js
 **/